import styled from "styled-components"
import { Title } from "../../../../../../../../../_webui/layout/components/Typography/Title"
import { Colors } from "../../../../../../../../../constant/Styled/Colors"
import { SchedulesAddTable } from "../../../../Table"

const { BG_WIDGET, FORM_ENTRY_BORDER, TABLE_HEADER, TABLE_SELECTED } = Colors

const StyledTableRemark = styled.div`
  .ant-table-cell .ant-form-item .ant-form-item-label {
    height: initial;
    min-height: initial;
    text-indent: initial;
    width: 100%;
    > label {
      height: initial;
    }
    &-focused {
      transform: translateY(15px);
    }
    &-left {
      .form-label {
        font-size: 14px;
        height: initial;
        min-height: initial;
        text-indent: initial;
        width: initial;
      }
    }
  }
`

const StyledTitle = styled(Title)`
  background-color: ${TABLE_HEADER};
  border: 1px solid ${FORM_ENTRY_BORDER};
  padding: 6px;
`

const StyledErrorTitle = styled(Title)`
  margin-left: 15px;
`

const StyledSchedulesAddTable = styled(SchedulesAddTable)`
  .ant {
    &-table-row {
      .ant-table-cell {
        .ant-form-item-auto-complete .ant-select-focused {
          transform: translateY(0);
          margin-bottom: 0;
        }
        .ant-input-affix-wrapper-focused {
          transform: translateY(0);
          display: inline;
        }
      }
      &:nth-child(2n + 1) {
        background-color: ${BG_WIDGET};
        &.ant-table-row-selected {
          background-color: ${TABLE_SELECTED};
        }
      }
    }
  }
`

export const Styled = {
  StyledErrorTitle,
  StyledSchedulesAddTable,
  StyledTableRemark,
  StyledTitle,
}
